// Side-effect module: registers the host's analytics singleton with
// @p81-common/shell-core-js so MFE consumers (and federated host components
// loaded inside an MFE) import the SAME configured instance via:
//
//   import { analytics } from "@p81-common/shell-core-js";
//
// Must be imported eagerly from the host's bootstrap (App.tsx) before any
// MFE route is mounted — otherwise a federated chunk's duplicated copy of
// tools/analytics/index.js could win the setAnalytics race and overwrite
// the singleton pointer with an unconfigured instance, causing publish
// events to fail with empty user_attributes (400 from yarkon-events).

import { setAnalytics } from "@p81-common/shell-core-js";
import { analytics } from "./index";

setAnalytics(analytics);
